const addToCartProduct = (idProduct, qty) => {
    const url = '/cart/add.js';
    const data = { quantity: qty, id: idProduct };

    fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then(response => response.json())
        .then(() => {
            fetch(`/?section_id=global--cart-drawer`)
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                let cartFuntion = new CartDrawer()

                cartFuntion.getSectionsToRender().forEach((section) => {
                    document.getElementById(section).innerHTML = cartFuntion.getSectionInnerHTML(state, section);
                });
                cartFuntion.openCart();
                cartFuntion.remountUpsell();
                cartFuntion.bindEvents();
                cartFuntion.updateCartCount();
              });
        })
        .catch(error => {
            console.error('Error al agregar el producto al carrito:', error);
        });
}

document.addEventListener("DOMContentLoaded", function() {
    const $form = document.querySelector(".js-product_section .product_form .shopify-product-form");

    if($form) {
        $form.addEventListener("submit", function(event) {
            event.stopPropagation();
            event.preventDefault();
            let $idProduct = $form.querySelector('[name="id"]').value
            let qty = $form.querySelector('.quantity').value
    
            addToCartProduct($idProduct, qty)
    
        })
    }

})